import { bind, forEach, isElement, isNil } from "lodash";

const
    selectors = {
        base: ".js-radioplayer"
    };

function playClick() {
    this._togglePlay();
}

function openerClick() {
    this._openPlayer();
}

function play() {
    this._toggleShowPlay();
}

function pause() {
    this._toggleShowPlay();
}
/**
 * JS module for the Radio Player
 */
export default class RadioPlayer {

    constructor(baseElement) {

        if (!isElement(baseElement) || isNil(baseElement.id)) {
            return // Insufficient data to render player
        }

        this._config(baseElement);
    }

    _openPlayer() {
        let control = document.getElementById(this.controlid);

        window.open(control.dataset.href, control.dataset.target, "popup,width=1100,height=475");
    }

    _togglePlay() {
        let player = document.getElementById(this.playerid);

        if (player.paused) {
            // when the player was paused, the source was cleared to prevent buffering - so the source must be restored and the player reload to continue playback
            if (!player.getAttribute('src') && !isNil(this.source)) {
                player.setAttribute('src', this.source)
                player.load();
            }

            player.play();
        } else {
            player.pause();
        }
    }

    _toggleShowPlay() {
        let player = document.getElementById(this.playerid);
        let control = document.getElementById(this.controlid);

        if (!player.paused) {
            // play
            control.classList.remove('c-tag--play');
            control.classList.add('c-tag--pause');
        } else {
            // pause
            this.source = player.getAttribute('src');

            // by clearing the source and reloading the player, we ensure the live stream is continued at the current time instead of resuming buffered playback
            // this also stops downloading the stream while being paused, saving data.
            setTimeout(function () {
                player.setAttribute('src', '');

                setTimeout(function () {
                    player.load();
                })
            });

            control.classList.remove('c-tag--pause');
            control.classList.add('c-tag--play');
        }
    }

    _bindOpenerEvents() {
        document.getElementById(this.controlid).addEventListener('click', bind(openerClick, this));
    }

    _bindPlayerEvents() {
        document.getElementById(this.controlid).addEventListener('click', bind(playClick, this));
        document.getElementById(this.playerid).addEventListener('play', bind(play, this));
        document.getElementById(this.playerid).addEventListener('pause', bind(pause, this));
    }

    _config(baseElement) {
        this.controlid = baseElement.id;
        this.playerid = `radioplayer-${baseElement.dataset.playerid}`;

        switch (baseElement.dataset.type) {
            case "opener":
                this._bindOpenerEvents();
                break;
            case "player":
                this._bindPlayerEvents();
                break;
        }

    }
}

forEach(document.querySelectorAll(selectors.base), player => {
    new RadioPlayer(player);
});